import { createI18n, type VueMessageType } from 'vue-i18n';

type NamespaceMessages = Record<string, VueMessageType>;

type JsonModule = { default: NamespaceMessages };

type LocaleEntry = Record<string, NamespaceMessages | Record<string, NamespaceMessages>>;

const coreLocales = import.meta.glob<JsonModule>('@nova/core-locales/**/*.json', { eager: true });
const satelliteLocales = import.meta.glob<JsonModule>('@satellite/locales/**/*.json', {
  eager: true
});
const appLocales = import.meta.glob<JsonModule>('@/locales/**/*.json', { eager: true });

function loadLocaleMessages() {
  const coreByLocale: Record<string, Record<string, NamespaceMessages>> = {};
  const nsByLocale: Record<string, Record<string, NamespaceMessages>> = {};

  for (const [path, mod] of Object.entries(coreLocales)) {
    const m = path.match(/\/locales\/([a-zA-Z-]+)\/([a-zA-Z-]+)\.json$/);
    if (!m) {
      console.warn('Unmatched locale path:', path);
      continue;
    }
    const [, locale, ns] = m;
    if (!locale || !ns) continue;
    coreByLocale[locale] = { ...coreByLocale[locale], [ns]: mod.default };
  }

  for (const [path, mod] of [...Object.entries(satelliteLocales), ...Object.entries(appLocales)]) {
    const m = path.match(/\/locales\/([a-zA-Z-]+)\/([a-zA-Z-]+)\.json$/);
    if (!m) {
      console.warn('Unmatched locale path:', path);
      continue;
    }
    const [, locale, ns] = m;
    if (!locale || !ns) continue;
    nsByLocale[locale] = { ...nsByLocale[locale], [ns]: mod.default };
  }

  const allLocales = new Set([...Object.keys(coreByLocale), ...Object.keys(nsByLocale)]);
  const messages: Record<string, LocaleEntry> = {};

  for (const locale of allLocales) {
    const entry: LocaleEntry = { ...nsByLocale[locale] };
    if (locale in coreByLocale) {
      entry['core'] = coreByLocale[locale];
    }
    messages[locale] = entry;
  }

  if ('es-mx' in messages && !('es' in messages)) {
    messages['es'] = messages['es-mx'];
  }

  if ('pt-br' in messages && !('pt' in messages)) {
    messages['pt'] = messages['pt-br'];
  }

  return messages;
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'en',
  fallbackLocale: 'en',
  messages: loadLocaleMessages()
});

export default i18n;
